import { Component, Inject, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LibService } from '../../services/libService';
import { TranslatorService } from '../../services/translate.service';
import { TypologiesRelationshipsBetweenPracticeService } from '../../services/typologiesRelationshipsBetweenPractice.service'

@Component({
    selector: 'app-connect-a-new-practice-modal',
    templateUrl: './connect-a-new-practice-modal.component.html',
    styleUrls: ['./connect-a-new-practice-modal.component.scss']
})
export class ConnectANewPracticeModal implements OnInit {

    titleLabel: string = ''
    textLabel: string = ''
    confirmButtonLabel: any = 'LABEL.ADD'
    cancelButtonLabel: any = 'LABEL.CANCEL'

    form: FormGroup
    typologiesRelationshipsBetweenPractices: any = []

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private libService: LibService,
        private translate: TranslatorService,
        private fb: FormBuilder,
        private typologiesRelationshipsBetweenPracticeService: TypologiesRelationshipsBetweenPracticeService,
    ) {

        this.form = this.fb.group({
            practiceId: [null, [Validators.required]],
            typologiesRelationshipsBetweenPracticeId: [null, [Validators.required]]
        })

        if (data) {

            if (data.practice) {
                this.form.get('practiceId')?.setValue(`${data.practice.id}`)
            }

        }

    }

    initTypologiesRelationshipsBetweenPractice() {
        this.typologiesRelationshipsBetweenPracticeService.index().subscribe((response: any) => {
            // solo quelli con visible a true
            this.typologiesRelationshipsBetweenPractices = response.filter((item: any) => item.visible)
        });
    }

    ngOnInit(): void {

        this.initTypologiesRelationshipsBetweenPractice()

    }

}